import { ProjectionIndicatorCategory } from '@enums/projection-indicator-category.enum';
import { ProjectionIndicatorType } from '@enums/projection-indicator-type.enum';
import { ArithmeticHelper } from '@helpers/arithmetic.helper';

export interface ProjectionIndicatorLineJson {
  projection_indicator_category: ProjectionIndicatorCategory;
  projection_indicator_type: ProjectionIndicatorType;
  accounting_amount: number | null;
  projection_amount: number | null;
}

export class ProjectionIndicatorLine {
  constructor(
    public projectionIndicatorCategory: ProjectionIndicatorCategory,
    public projectionIndicatorType: ProjectionIndicatorType,
    public accountingAmount: number | null,
    public projectionAmount: number | null
  ) {}

  static fromJson(json: ProjectionIndicatorLineJson): ProjectionIndicatorLine {
    return new ProjectionIndicatorLine(
      json.projection_indicator_category,
      json.projection_indicator_type,
      ProjectionIndicatorLine.parseAmount(json.accounting_amount, json.projection_indicator_type),
      ProjectionIndicatorLine.parseAmount(json.projection_amount, json.projection_indicator_type)
    );
  }

  static toJson(data: ProjectionIndicatorLine): ProjectionIndicatorLineJson {
    return {
      projection_indicator_category: data.projectionIndicatorCategory,
      projection_indicator_type: data.projectionIndicatorType,
      accounting_amount: ProjectionIndicatorLine.serializeAmount(data.accountingAmount, data.projectionIndicatorType),
      projection_amount: ProjectionIndicatorLine.serializeAmount(data.projectionAmount, data.projectionIndicatorType)
    };
  }

  static getCategoryForType(type: ProjectionIndicatorType): ProjectionIndicatorCategory {
    switch (type) {
      case ProjectionIndicatorType.ratioEbe:
      case ProjectionIndicatorType.ratioNetResult:
        return ProjectionIndicatorCategory.activity;
      case ProjectionIndicatorType.cashBalance:
      case ProjectionIndicatorType.loanBalance:
      case ProjectionIndicatorType.immobilisationBrute:
        return ProjectionIndicatorCategory.financial;
      case ProjectionIndicatorType.totalRemunerationTns:
      case ProjectionIndicatorType.totalPrelevementTns:
      case ProjectionIndicatorType.compteCourantBalance:
      case ProjectionIndicatorType.projectedDividends:
        return ProjectionIndicatorCategory.director;
      case ProjectionIndicatorType.is:
      case ProjectionIndicatorType.isBalance:
      case ProjectionIndicatorType.socialChargesBalance:
        return ProjectionIndicatorCategory.taxation;
      default:
        throw new Error(`Unknown indicator type: ${type}`);
    }
  }

  private static parseAmount(amount: number | null, type: ProjectionIndicatorType): number | null {
    switch (type) {
      case ProjectionIndicatorType.ratioEbe:
      case ProjectionIndicatorType.ratioNetResult:
        return amount !== null ? ArithmeticHelper.mul(amount, 100, 4) : null;
      default:
        return amount !== null ? amount : null;
    }
  }

  private static serializeAmount(amount: number | null, type: ProjectionIndicatorType): number | null {
    switch (type) {
      case ProjectionIndicatorType.ratioEbe:
      case ProjectionIndicatorType.ratioNetResult:
        return amount !== null ? ArithmeticHelper.div(amount, 100, 4) : null;
      default:
        return amount !== null ? amount : null;
    }
  }
}
